import { render } from "./TalALibraryBlack.vue?vue&type=template&id=238fa605&scoped=true"
import script from "./TalALibraryBlack.vue?vue&type=script&lang=js"
export * from "./TalALibraryBlack.vue?vue&type=script&lang=js"

import "./TalALibraryBlack.vue?vue&type=style&index=0&id=238fa605&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238fa605"]])

export default __exports__